import * as Yup from 'yup';

export const trainerMOUValidationSchema = Yup.object({
  trainer_id: Yup.number().required('Trainer Name is required'),
  mou_amount: Yup.number().required('Amount is required'),
  mou_transaction_date: Yup.string().nullable().required('Date is required'),
  mou_payment_mode: Yup.string().required('Payment Mode is require'),
});
